import { render, staticRenderFns } from "./DateInputTextField.vue?vue&type=template&id=5b44a661&scoped=true"
import script from "./DateInputTextField.vue?vue&type=script&lang=js"
export * from "./DateInputTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b44a661",
  null
  
)

export default component.exports